<template>
  <div>
    <cv-navbar/>
    <div class="success-main">
      <div class="title">
        <div class="icon">
          <div class="back"></div>
          <span class="iconfont iconwancheng"></span>
        </div>
        <p class="text">支付成功，您已成为{{isSuper ? (superType==='superplus' ? '超级会员' : superType === 'plus' ? '终身会员 PLUS' : '终身会员') : '超级简历会员'}}</p>
        <p class="member-tips">恭喜解锁会员福利，赶快领取吧！</p>
        <div class="img">
          <img src="https://logo.wondercv.com/banners/9BSi2QTR6gduJX4.png" style="width: 100%;height: 100%" alt="">
        </div>
        <p class="member-code-tips">扫码添加小助手，即可进入会员专享求职社群，还可领取导师辅导 20 元优惠券哦</p>
      </div>
      <div v-if="rightsListData && rightsListData.length" class="rights-block-wrapper">
        <div class="rights-title">{{ rightsContentTitle }}
          <span v-if="rightsIds.length < 4" @click="handleCreateOrder(1000)">立即升级</span>
        </div>
        <div class="rights-list-content">
          <div
            v-for="(item, index) in rightsListData"
            :key="index"
            class="rights-item"
            :class="{'active': item.recieve_method}"
          >
            <div class="rights-item-title">{{ item.title }}</div>
            <div class="rights-item-subtitle">{{ item.subtitle }}</div>
            <div
              v-if="item.recieve_method"
              class="rights-item-btn"
            >
            <el-popover
              popper-class="recieve-popover"
              trigger="hover"
              placement="right"
            >
              <img class="recieve-method-img" :src="item.recieve_method" />
              <div slot="reference">领取</div>
            </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <p>会员权益说明</p>
        <p>
          1. 购买后即刻生效，请在有效期内使用，逾期失效；<br>
          2. 可在我的订单中查看所有购买记录；<br>
          3. 成为会员后，即刻享有对应会员特权；<br>
          4. 会员服务如有任何问题，可在工作日联系人工客服解决，人工客服在线时间：10:00-19:00<br>
          5. 最终解释权归超级简历所有，如有疑问，请联系在线客服<br>
        </p>
      </div>
    </div>
    <pay-alert v-if="showAlert" @close="showAlert=false" :active-pic="active" :order-id="orderId"/>
    <forever-vip-coupon :alert-state="alertState" @closeDialog="alertState = false" @handleClickPay="handleCreateOrder"></forever-vip-coupon>
  </div>
</template>

<script>
  import cvNavbar from '@/components/base/navbar';
  import foreverVipCoupon from './foreverVipCoupon';
  import payAlert from "./payAlert";
  import { mapState, mapActions } from "vuex";
  import { routerTo, get_tUser } from '@/assets/js/util'
  import Cookies from "js-cookie";
  import {toLogin} from "@/assets/js/jwt";
  import api from "@/api";
  import { MONTH_PRICE, YEAR_PRICE, FOREVER_PRICE, BUY_IN } from '@/assets/js/const'

  export default {
    name: "pay-success",
    components: { cvNavbar, payAlert, foreverVipCoupon },
    computed: {
      ...mapState('global', ['nonChrome']),
      ...mapState('me', ['purchaseRecordData']),
    },
    data() {
      return {
        img: "https://logo.wondercv.com/banners/9BSi2QTR6gduJX4.png",
        isSuper: false,
        alertState: false,
        superType: '',
        type: '',
        pri: [
          {icon: 'https://files.wondercv.com/pc/member/member-1.png', title: "简历容量增加"},
          {icon: 'https://files.wondercv.com/pc/member/member-2.png', title: "简历模板解锁"},
          {icon: 'https://files.wondercv.com/pc/member/member-5.png', title: "智能修改+翻译"},
          {icon: 'https://files.wondercv.com/pc/member/member-4.png', title: "简历误删恢复"},
          {icon: 'https://files.wondercv.com/pc/member/payment_fuli.png', title: "MBTI职业测试"},
          {icon: 'https://files.wondercv.com/pc/member/member-6.png', title: "导师辅导专属福利"},
        ],
        routerTo,
        showAlert: false,
        orderId: "",
        active: FOREVER_PRICE,
        rightsListData: [],
        orderDetailData: {}
      }
    },
    computed: {
      rightsIds() {
        if (this.rightsListData) {
          return this.rightsListData.filter(item => !!item.recieve_method)
        } else {
          return []
        }
      },
      rightsContentTitle() {
        switch (this.rightsIds.length) {
          case 4:
            return '恭喜解锁全部求职包，快来领取吧～';
          case 0:
          case 1:
          case 2:
          case 3:
            return '升级终身会员解锁全部求职包！';
        }
      }
    },
    async created() {
      let {type, state} = this.$route.query
      // type = vip | rightsVip | month | rightsMonth | super
      this.type = type;
      if (type === 'super' || type === 'plus' || type === 'superplus') {
        this.isSuper = true
        this.superType = type
      } else {
        this.isSuper = false
      }
      this.fetchOrderDetailData();
      if ((type === 'month' || type === 'rightsMonth') && +state === BUY_IN) {
        await this.getPurchaseRecordData();
        this.alertState = true;
      }
    },
    methods: {
      ...mapActions('me', ['getPurchaseRecordData']),
      goToCvs() {
        this.routerTo('/cvs')
      },
      async fetchOrderDetailData() {
        try {
          const { c_t } = get_tUser()
          const { orderId } = this.$route.query
          const { code, data } = await api.account.getOrderAlert(c_t, orderId, { type: 'improved_order'});
          if (code === 1000) {
            this.orderDetailData = data.order;
            this.rightsListData = data.order?.rights || []
          }
        } catch (error) {
          console.log(error)
        }
      },
      async handleCreateOrder(pic) {
        let _t = Cookies.get('_t');
        if (!_t) {
          toLogin({login:true});
          return
        }
        try {
          let member_period = 1000
          if (pic != 1000) {
            if (this.active == MONTH_PRICE) {
              member_period = 1
            } else if (this.active == 45) {
              member_period = 3
            } else if (this.active == YEAR_PRICE) {
              member_period = 12
            } else if (this.active == FOREVER_PRICE) {
              member_period = 1000
            } else if (this.active === 119) {
              member_period = 2000
            }
          }
          let res = await api.account.createOrder({member_period, has_rights: 'true'})
          let {code, data: {token}} = res
          if (code === 1000) {
            this.orderId = token
            this.showAlert = true
          }
        } catch (e) {
          console.log(e)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .success-main {
    //width: 910px;
    //height: 670px;
    width: 100%;
    height: 1000px;
    background: #fff;
    margin: 56px auto 0;
    //padding: 48px;
    box-sizing: border-box;
    position: relative;
    .title{
      width: 100%;
      height: 600px;
      background-image: url("https://files.wondercv.com/pc/member/top-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      position: relative;
      .member-desc{
        position: absolute;
        left: 50%;
        bottom: -79px;
        transform: translateX(-50%);
        width: 707px;
        // height: 154px;
        background: #FFFFFF;
        box-shadow: 0px 6px 48px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        img{
          width: 100%;
          // height: 100%;
          display: block;
        }
      }
      .member-tips{
        opacity: .7;
        margin-top: 16px;
      }
      .img {
        width: 281px;
        height: 281px;
        margin: 32px auto 0;
        text-align: center;
        & > img {
          width: 100%;
          height: 100%;
        }
      }
      .member-code-tips{
        font-size: 16px;
        margin-top: 24px;
        line-height: 26px;
        text-align: center;
      }
      
      .text{
        font-size: 24px;
        font-weight: bold;
        margin-top: 16px;
      }
      .icon{
        text-align: center;
        color: #ff6644;
        //background-color: #fff;
        border-radius: 50%;
        margin-top: 32px;
        position: relative;
        .back{
          width: 84%;
          height: 84%;
          background-color: #fff;
          position: absolute;
          left: 8%;
          top: 8%;
          border-radius: 50%;
          z-index: 7;
        }
        .iconfont{
          position: relative;
          font-size: 36px;
          z-index: 8;
        }
      }
    }

    .rights-block-wrapper {
      position: relative;
      background-color: #fff;
      border-radius: 8px;
      margin: -55px auto 0;
      padding: 32px 24px;
      box-shadow: 0px 6px 48px 0px rgba(0,0,0,0.06);
      box-sizing: border-box;
      z-index: 1;
      width: min-content;
      .rights-title {
        font-size: 16px;
        color: #3B3F57;
        font-weight: 600;
        margin-bottom: 24px;
        span {
          color: #ff6644;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .rights-list-content {
        display: flex;
        align-items: center;
        .rights-item {
          position: relative;
          width: 200px;
          height: 78px;
          color: #3B3F57;
          padding-top: 20px;
          padding-left: 18px;
          box-sizing: border-box;
          border-radius: 8px;
          background-image: url('https://logo.wondercv.com/banners/1GREr7NAGNvb3zX.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          &:not(:last-child) {
            margin-right: 18px;
          }
          &-title {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
          }
          &-subtitle {
            font-size: 12px;
          }
          &-btn {
            position: absolute;
            right: 16px;
            bottom: 19px;
            font-size: 12px;
            text-decoration: underline;
            cursor: pointer;
          }
          &.active {
            background-image: url('https://logo.wondercv.com/banners/R5QLvAXpzhs5N7E.png');
            color: #fff;
          }
        }
      }
    }

    .text-welfare{
      width: 100%;
      color: #494D5B;
      font-size: 14px;
      text-align: center;
      margin-top: 24px;
      .to-super-member{
        color: #ff6644;
        cursor: pointer;
        margin-left: 5px;
        position: relative;
        &:after{
          content: '';
          width: 56px;
          height: 0;
          position: absolute;
          right: 0;
          bottom: 2px;
          border-bottom: 1px solid #ff6644;
        }
      }
    }

    //.desc {
    //  width: 485px;
    //  height: 66px;
    //  font-size: 14px;
    //  font-family: PingFangSC-Regular, PingFang SC;
    //  font-weight: 400;
    //  color: #404040;
    //  line-height: 22px;
    //  margin: 8px auto 28px;
    //
    //  i {
    //    margin-right: 12px;
    //    color: #FF6644
    //  }
    //
    //  span {
    //    color: #FF6644;
    //  }
    //
    //  a {
    //    color: #FF6644;
    //  }
    //}

    .item {
      width: 713px;
      margin-top: 44px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #494D5B;
      line-height: 24px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);

      .title-bold{
        font-weight: bold;
      }

      p:first-child{
        font-size: 16px;
        font-weight: bold;
      }
      p:nth-child(2){
        margin-top: 10px;
      }
    }
  }
</style>
<style>
.recieve-popover {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 180px;
  height: 180px;
}
.el-popover .recieve-method-img {
  width: 162px;
  height: 162px;
  object-fit: cover;
}
</style>
